import React, { useState, useEffect } from 'react';
import { addIntern, getInterns, updateIntern } from '../../service/apiService';
import { Card, Form, Button, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import './Interns.css';

function Interns({ user }) {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',

    parent_name: '',
    parent_number: '',
    parent_relation: '',

    college_name: '',
    college_department: '',

    internship_role: '',
    internship_fee: '',
    start_date: '',
    end_date: '',
    remarks: '',
  });
const [interns, setInterns] = useState([]);
const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 5;
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

const fetchInterns = async () => {
  try {
    const res = await getInterns();

    if (res.status === 'success') {
      setInterns(res.data);
    } else {
      setInterns([]);
    }
  } catch (err) {
    console.log(err);
  }
};
useEffect(() => {
  fetchInterns();
}, []);

 const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  const payload = {
    ...formData,
    created_by: user?.id,
  };

  let res;

  if (editId) {
    res = await updateIntern(editId, payload);
  } else {
    res = await addIntern(payload);
  }

  setLoading(false);

  if (res.status === 'success') {

    alert(editId ? 'Intern updated successfully!' : 'Intern added successfully!');

    setFormData({
      name: '',
      phone: '',
      email: '',

      parent_name: '',
      parent_number: '',
      parent_relation: '',

      college_name: '',
      college_department: '',

      internship_role: '',
      internship_fee: '',
      start_date: '',
      end_date: '',
      remarks: '',
    });

    setEditId(null);

    fetchInterns(); // refresh table after add/update

  } else {

    alert(`Error: ${res.message || 'Unable to save intern'}`);

  }
};
const indexOfLast = currentPage * itemsPerPage;
const indexOfFirst = indexOfLast - itemsPerPage;

const currentInterns = interns.slice(indexOfFirst, indexOfLast);

const totalPages = Math.ceil(interns.length / itemsPerPage);

const handleEdit = (item) => {

  setEditId(item.id);

  setFormData({
    name: item.name || '',
    phone: item.phone || '',
    email: item.email || '',

    parent_name: item.parent_name || '',
    parent_number: item.parent_number || '',
    parent_relation: item.parent_relation || '',

    college_name: item.college || '',
    college_department: item.department || '',

    internship_role: item.internship_role || '',
    internship_fee: item.internship_fee || '',
    start_date: item.start_date || '',
    end_date: item.end_date || '',
    remarks: item.remarks || '',
  });

  window.scrollTo({
    top:0,
    behavior:'smooth'
  });
};

  return (
    <div className="interns-page">

      <h3 className="mb-4">Add Intern</h3>


      <Card className="shadow-sm p-4">

        <Form onSubmit={handleSubmit}>


          {/* Intern Details */}

          <Row>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Intern Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>


            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>


          </Row>



          <Row>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>


          </Row>




          {/* Parent Details */}

          <h5 className="mt-3">Parent Details</h5>


          <Row>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Parent Name</Form.Label>

                <Form.Control
                  type="text"
                  name="parent_name"
                  value={formData.parent_name}
                  onChange={handleChange}
                />

              </Form.Group>
            </Col>


            <Col md={6}>
              <Form.Group className="mb-3">

                <Form.Label>Parent Number</Form.Label>

                <Form.Control
                  type="text"
                  name="parent_number"
                  value={formData.parent_number}
                  onChange={handleChange}
                />

              </Form.Group>
            </Col>


          </Row>




          <Row>

            <Col md={6}>

              <Form.Group className="mb-3">

                <Form.Label>Relation With Parent</Form.Label>

                <Form.Control
                  type="text"
                  name="parent_relation"
                  value={formData.parent_relation}
                  onChange={handleChange}
                  placeholder="Father / Mother / Guardian"
                />

              </Form.Group>

            </Col>

          </Row>






          {/* College Details */}


          <h5 className="mt-3">College Details</h5>


          <Row>


            <Col md={6}>

              <Form.Group className="mb-3">

                <Form.Label>College Name</Form.Label>

                <Form.Control
                  type="text"
                  name="college_name"
                  value={formData.college_name}
                  onChange={handleChange}
                  required
                />

              </Form.Group>

            </Col>



            <Col md={6}>

              <Form.Group className="mb-3">

                <Form.Label>Department</Form.Label>

                <Form.Control
                  type="text"
                  name="college_department"
                  value={formData.college_department}
                  onChange={handleChange}
                />

              </Form.Group>


            </Col>


          </Row>






          {/* Internship */}


         <Row>
  <Col md={4}>
    <Form.Group className="mb-3">
      <Form.Label>Internship Role</Form.Label>
      <Form.Control
        type="text"
        name="internship_role"
        value={formData.internship_role}
        onChange={handleChange}
        placeholder="React Developer Intern"
        required
      />
    </Form.Group>
  </Col>

  <Col md={4}>
    <Form.Group className="mb-3">
      <Form.Label>Internship Fee</Form.Label>
      <Form.Control
        type="number"
        name="internship_fee"
        value={formData.internship_fee}
        onChange={handleChange}
        placeholder="Enter internship fee"
        min="0"
        required
      />
    </Form.Group>
  </Col>

  <Col md={4}>
    <Form.Group className="mb-3">
      <Form.Label>Start Date</Form.Label>
      <Form.Control
        type="date"
        name="start_date"
        value={formData.start_date}
        onChange={handleChange}
        required
      />
    </Form.Group>
  </Col>
</Row>





          <Row>

            <Col md={6}>

              <Form.Group className="mb-3">

                <Form.Label>End Date</Form.Label>

                <Form.Control
                  type="date"
                  name="end_date"
                  value={formData.end_date}
                  onChange={handleChange}
                />

              </Form.Group>


            </Col>


          </Row>






          <Form.Group className="mb-3">

            <Form.Label>Remarks</Form.Label>

            <Form.Control
              as="textarea"
              rows={3}
              name="remarks"
              value={formData.remarks}
              onChange={handleChange}
              placeholder="Any notes about this intern"
            />

          </Form.Group>





          <Button
            variant="primary"
            type="submit"
            disabled={loading}
          >
           {loading 
 ? "Saving..." 
 : editId 
 ? "Update Intern" 
 : "Submit Intern"}

          </Button>


        </Form>

      </Card>
<Card className="shadow-sm p-4 mt-4">

  <h5>Interns List</h5>

  <div className="table-responsive">

    <table className="table table-bordered table-hover">

      <thead className="table-dark">
        <tr>
          <th>Name</th>
          <th>Phone</th>
          <th>Email</th>
          <th>College</th>
          <th>Department</th>
          <th>Role</th>
          <th>Start Date</th>
          <th>Action</th>
        </tr>
      </thead>

      <tbody>

        {currentInterns.length > 0 ? (
          currentInterns.map((item) => (
            <tr key={item.id}>
              <td>{item.name}</td>
              <td>{item.phone}</td>
              <td>{item.email}</td>
              <td>{item.college}</td>
              <td>{item.department}</td>
              <td>{item.internship_role}</td>
              <td>{item.start_date}</td>
              <td>

<span
  onClick={() => handleEdit(item)}
  style={{
    cursor: 'pointer',
    color: '#0d6efd',
    fontSize: '18px'
  }}
>
  <FontAwesomeIcon icon={faPenToSquare} />
</span>

</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="8" className="text-center">
              No interns found
            </td>
          </tr>
        )}

      </tbody>

    </table>

  </div>
  <div className="d-flex justify-content-center align-items-center mt-3 gap-3">

  {/* Left Arrow */}
  <Button
    variant="light"
    disabled={currentPage === 1}
    onClick={() => setCurrentPage(currentPage - 1)}
    style={{ fontSize: '20px', fontWeight: 'bold' }}
  >
    ‹
  </Button>

  {/* Page Info */}
  <span style={{ fontWeight: 500 }}>
    {currentPage} / {totalPages || 1}
  </span>

  {/* Right Arrow */}
  <Button
    variant="light"
    disabled={currentPage === totalPages || totalPages === 0}
    onClick={() => setCurrentPage(currentPage + 1)}
    style={{ fontSize: '20px', fontWeight: 'bold' }}
  >
    ›
  </Button>

</div>

</Card>


    </div>
  );
}


export default Interns;
